<template>
  <div v-loading="isLoading">
    <el-card shadow="never">
      <Label
        ref="form"
        :form-data="formData.shipperData"
      />
    </el-card>
  </div>
</template>
<script>
import Label from '@/components/Application/Manage/Carriers/Carrier/Label'
export default {
  components: {
    Label
  },
  data () {
    return {
      title: 'Label',
      breadcrumb: {
        name: 'Label',
        route: { name: 'manage-carriers-carrier-configurations-label' }
      },
      actions: [
        {
          name: 'Save',
          icon: ['fal', 'save'],
          event: this.save
        }
      ],
      isSaving: false,
      isLoading: false,
      carrier: [],
      formData: {
        shipperData: {
          labelTemplate: null,
          template: null,
          printConnote: false,
          printLabel: false
        }
      }
    }
  },
  mounted () {
    this.loadCarrierById()
  },
  methods: {
    loadCarrierById () {
      this.isLoading = true
      this.$sdk.carrier.read(this.$route.params.carrierId, (builder) => {
      }).then(res => {
        this.carrier = res
        this.formData.shipperData.template = res.con_template
        this.formData.shipperData.labelTemplate = res.label_template
        this.formData.shipperData.printConnote = res.print_connote
        this.formData.shipperData.printLabel = res.print_label
      })
        .finally(() => {
          this.isLoading = false
        })
    },
    save () {
      this.isSaving = true
      this.carrier.con_template = this.formData.shipperData.template
      this.carrier.label_template = this.formData.shipperData.labelTemplate
      this.carrier.print_connote = this.formData.shipperData.printConnote
      this.carrier.print_label = this.formData.shipperData.printLabel
      this.$refs.form.$refs.form.validate((valid) => {
        if (valid) {
          this.carrier.update()
            .then(() => this.$message({ message: 'Successfully saved', type: 'success' }))
            .finally(() => {
              this.isSaving = false
            })
        }
      })
    }
  }
}
</script>
